import { render } from "./Education.vue?vue&type=template&id=20e4020a&scoped=true"
import script from "./Education.vue?vue&type=script&lang=js"
export * from "./Education.vue?vue&type=script&lang=js"

import "./Education.vue?vue&type=style&index=0&id=20e4020a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-20e4020a"

export default script